






















































import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import { TurnoDeVenda, UsuarioBase, Venda } from '@/models'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'

@Component({
	components: {
		SeletorDeUsuario,	
	},
})
export default class DialogoDeInformarVendedor extends Vue {
	@Ref() form!: HTMLFormElement
	mostra: boolean | null = false
	vendedor: UsuarioBase | null = null

	get venda() {
		return VendaModule.vendaAtual as Venda
	}
	
	set venda(venda: Venda) {
		VendaModule.setVendaAtual(venda)
	}

	get turno() {
		return VendaModule.turnoDeVenda as TurnoDeVenda
	}

	mostrar() {
		this.mostra = true
		this.vendedor = VendaModule.vendaAtual?.vendedor || null
	}

	fechar(){
		this.mostra = false
	}

	async informarVendedor(){
		this.venda = {
			...this.venda,
			vendedor: this.vendedor,
		}
		this.mostra = false
	}	

	@Watch('mostra')
	onChangeMostra(mostra: boolean, mostraAnterior: boolean) {
		if (mostra && !mostraAnterior) {
			this.vendedor = this.venda.vendedor
			window.requestAnimationFrame(() => {
				this.form.resetValidation()
			})
		}
	}

}
